import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
/**
 * CSS-based label renderer for number line labels.
 * Parses formatted strings and renders fractions/mixed numbers
 * using CSS flexbox (no MathJax). Follows CellValue pattern from NumberCharts.
 */
var NumberLineLabel = memo(function (_a) {
    var value = _a.value;
    if (!value)
        return null;
    // Check for negative sign
    var isNegative = value.startsWith('-');
    var workValue = isNegative ? value.slice(1) : value;
    // Mixed number: "2\frac{3}{4}"
    var mixedMatch = workValue.match(/^(\d+)\\frac\{(\d+)\}\{(\d+)\}$/);
    if (mixedMatch) {
        var integer = mixedMatch[1], numerator = mixedMatch[2], denominator = mixedMatch[3];
        return (_jsxs("span", { className: "nlMixedWrapper", children: [isNegative && _jsx("span", { "aria-hidden": "true", children: "\u2212" }), _jsx("span", { children: integer }), _jsxs("span", { className: "nlFraction", children: [_jsx("span", { className: "nlFracNumerator", children: numerator }), _jsx("span", { className: "nlFracDenominator", children: denominator })] })] }));
    }
    // Fraction: "\frac{1}{2}"
    var fracMatch = workValue.match(/^\\frac\{(\d+)\}\{(\d+)\}$/);
    if (fracMatch) {
        var numerator = fracMatch[1], denominator = fracMatch[2];
        return (_jsxs("span", { className: "nlFractionOnly", children: [isNegative && _jsx("span", { className: "nlNegativeSign", "aria-hidden": "true", children: "\u2212" }), _jsxs("span", { className: "nlFraction", children: [_jsx("span", { className: "nlFracNumerator", children: numerator }), _jsx("span", { className: "nlFracDenominator", children: denominator })] })] }));
    }
    // Integer or decimal — simple text
    return _jsx("span", { children: isNegative ? "\u2212".concat(workValue) : value });
}, function (prevProps, nextProps) { return prevProps.value === nextProps.value; });
NumberLineLabel.displayName = 'NumberLineLabel';
export default NumberLineLabel;
